import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { PurchaseOrderLineRequirement } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderLineRequirementService extends TmsWebBaseEditCreateService<
  PurchaseOrderLineRequirement,
  PurchaseOrderLineRequirement
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('PurchaseOrderLineRequirement', $localize`Purchase Order Line Requirement`);
  }

  createPurchaseOrderRequirements(
    purchaseOrderLineId: string,
    purchaseOrderLineRequirementId,
  ): Observable<PurchaseOrderLineRequirement[]> {
    return this.httpService.get<PurchaseOrderLineRequirement[]>(
      `${this.apiUrl}/CreatePurchaseOrderRequirements/${purchaseOrderLineId}${
        purchaseOrderLineRequirementId ? `/${purchaseOrderLineRequirementId}` : ''
      }`,
    );
  }

  updateRequirements(purchaseOrderLineId: string, quantity: number): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/UpdateRequirements`, {
      purchaseOrderLineId,
      quantity,
    });
  }
}
